export default {
    orgLogo: (orgName) => `${orgName} logo`,
    appLogo: (appName) => `${appName} logo`,
    page: (numPages) => `Page${numPages === 1 ? '' : 's'}`,
    closePreview: `Close Preview`,
    saveFinish: `Save & Finish`,
    saveFinishLater: `Save & Finish Later`,
    saveFinishLaterDesc: `You can save your progress on this form and complete it later. 
        A link that will allow you to continue will be emailed to you.`,
    pinRequired: `PIN Required`,
    pinRequiredDesc: `A PIN is required to view this form.`,
    alreadySubmitted: `This form has already been submitted`,
    submitPin: `Submit PIN`,
    goButton: `GO`,
    hint: `Hint`,
    dontKnowPin: `Don't know the PIN?`,
    formSaved: `The form has been saved`,
    mayCloseWindow: `You may now close this window.`,
    requiredAttachments: `Required Attachments`,
    requiredAttachmentsDesc: `Before you can submit, you must provide the following required attachments`,
    backToForm: `Back to Form`,
    submitTo: (orgName) => `Submit to ${orgName}`,
    submitForm: `Submit Form`,
    submitFormDesc: `To submit this form, we need some information about you.`,
    willBeEmailedConfirmation: `You will be emailed a confirmation to the email address provided.`,
    firstName: `First Name`,
    lastName: `Last Name`,
    emailAddress: `Email Address`,
    next: `Next`,
    saveProceedPayment: `Save & Proceed to Payment`,
    savingForm: `Saving Form`,
    formSaved: `Form Saved`,
    completeRequiredFields: `Please complete required fields`,
    submitFormAgree: (healthcareMode) => `
        Once you submit this form, you will not be able to edit or submit it again.
        ${healthcareMode ? `` : ` You'll be able to print or save the completed form after submission.`}
        <br><br>
        By submitting this form, you agree to the 
        <a href='https://kb.paperworkforms.com/terms-and-policies/terms-of-service' target='_blank'>terms of service</a>.
        <br><br>
    `,
    submittingForm: `Submitting Form`,
    attemptsRemaining: (remaining) => {
        let num = remaining || 'no';
        return `${num} attempt${num === 1 ? '' : 's'} remaining`;
    },
    tryAgainMinutes: (mins) => `you may try again in ${mins} minute${mins === 1 ? '' : 's'}`,
    contactForPin: (orgName, phone) => `Please contact ${orgName}${phone ? `at ${phone}` : ``} to retrieve the PIN for this form.`,
    unableToSaveForm: `Unable To Save Form`,
    formUnsavedChanges: `This form has unsaved changes which will be lost if you leave without saving.`,
    formNumOfNum: (cur, total) => `Form <span>${cur}</span> of <span>${total}</span>`,
    pageNumOfNum: (cur, total) => `Page <span>${cur}</span> of <span>${total}</span>`,
    previousPage: `Previous page`,
    nextPage: `Next page`,
    increaseZoom: `Increase zoom`,
    decreaseZoom: `Decrease zoom`,
    print: `Print`,
    downloadPdf: `Download PDF`,
    openAnotherDevice: `Open form on another device`,
    loadingPackage: `Loading form package`,
    redirectingTo: (domain) => `Redirecting to ${domain}`,
    paymentProcessingError: `Payment Processing Error`,
    paymentProcessingErrorDesc: (msg) => `
        An error has occurred while processing your payment:<br>
        ${msg}<br><br>
        You may either try to pay again, or quit and come back later. 
        The information you entered into this form has been saved and will not be lost if you close this page.
    `,
    paymentCancelled: `Payment cancelled`,
    processingPayment: `Processing payment`,
    paymentTookTooLong: `Payment took too long to complete`,
    paymentVerifyError: (orgName) => `
        Unfortunately we are unable to verify that the payment was successfully processed. 
        You may either try to pay again or contact ${orgName} and inquire about this form's payment.<br><br>
        The information you entered into this form has been saved and will not be lost if you close this page.
    `,
    paymentSuccess: `Payment completed successfully`,
    signatures: `Signatures`,
    nextSignature: `Next Signature`,
    formBackgroundImage: `Form background image`,
    paymentCompleted: `Payment Completed`,
    paymentRequired: `Payment Required`,
    total: `TOTAL`,
    viewReceipt: `View Receipt`,
    paymentRedirectError: `
        An error has occurred and your payment could not be completed. 
        The payment processor that redirected you here may be incorrectly configured. 
        Please contact the organization that sent you the form to report this issue and ask for instructions on how to proceed.
    `,
    submissionSuccessful: `Submission Successful`,
    receiveCopyEmail: `You'll receive a copy of your submission by email`,
    printConfirmation: `Print Confirmation<br>Receipt`,
    printSubmittedForms: `Save/Print<br>Submitted Forms`,
    confirmation: `Confirmation`,
    submittedBy: `Submitted By`,
    submittedTo: `Submitted To`,
    submittedForms: `Submitted Forms`,
    attachments: `Attachments`,
    paymentSummary: `Payment Summary`,
    poweredBy: (appName) => `Powered by ${appName}`,
    dateAtTime: `at`,
    formSavedEmailLink: `This form has been saved. This link has been emailed to you and will allow you to continue editing at any time.`,
    mayCloseOrContinue: `You may now close this window, or continue editing the form.`,
    printCompletedForm: `Print completed form`,
    downloadCompletedForm: `Download completed form`,
    formDoesNotExist: `The requested form does not exist`,
    creatingPdf: `Creating PDF`,
    pdfNotFound: `The requested PDF could not be found.`,
    pdfError: `PDF Error`,
    fieldIsRequired: `This field is required`,
    signatureIsRequired: `This signature is required`,
    mustBeChecked: `This field must be checked`,
    optionMustBeSelected: `One of these options must be selected`,
    fieldMustBeSelected: `One of these fields must be selected`,
    voidSignature: (num) => `Void Signature${num > 1 ? 's' : ''}`,
    voidSignatureDesc: (num, signers) => {
        const lastSigner = signers.length > 1 ? ` and ${signers.pop()}` : '';
        signers = signers.join(', ') + lastSigner;
        return `
            Editing this field will void the signature${num > 1 ? 's' : ''} by ${signers} on this form.
            <br><br>
            Are you sure you want to continue?
        `;
    },
    voidSignatureEdit: (num) => `Void Signature${num > 1 ? 's' : ''} & Edit`,
    fieldIncorrectFormatting: (num) => num > 1
        ? `${num} fields have incorrect formatting.`
        : `This field has incorrect formatting.`,
    invalidValue: `Invalid Value`,
    cancel: `Cancel`,
    saveFormError: (orgName) => `
        We're sorry, an error was encountered while saving the form data. 
        To make sure you don't lose any of your work, please print the form by clicking the print button above. 
        Contact ${orgName} and ask how they would like you to submit the form. 
        We apologize for this issue, and will work to make sure it doesn't happen again in the future.
    `,
    pdfTabBlocked: (isPrint) => `
        A pop-up blocker has prevented ${isPrint ? 'print' : 'download'}ing.
        Please allow pop-ups from this site and try again.
    `,
    failRedirectToPayment: `Sorry, we are unable to redirect you to the payment processor at this time.`,
    requiredAttachment: `Required Attachment`,
    optionalAttachment: `Optional Attachment`,
    helpUploading: `Help with uploading files`,
    attachmentFormatsAccepted: `Formats accepted: PDF, images, word documents, spreadsheets`,
    noAttachedFiles: `No attached files`,
    helpUploadingDesc: `
        Files of the following formats are accepted: PDF, JPEG, PNG, GIF, DOC, DOCX, XLS, XLSX, ODT, ODS.
        <br><br> 
        Files can be a maximum of 25 MB each. 
        <br><br> 
        If you are having trouble uploading a file, check that the format is accepted, and that its size is less than 25 MB. 
        Then try uploading the file again.
    `,
    viewInitials: `View Initials`,
    viewSignature: `View Signature`,
    addYourInitials: `Add Your Initials`,
    addYourSignature: `Add Your Signature`,
    change: `Change`,
    drawSignature: (initials) => `Draw your ${initials ? 'initials' : 'signature'} in the box below:`,
    signature: `Signature`,
    signaturePlainText: (initials) => `Draw my ${initials ? 'initials' : 'signature'} in plain text`,
    signatureCursive: (initials) => `Draw my ${initials ? 'initials' : 'signature'} in cursive`,
    eraseSignature: (initials) => `Erase ${initials ? 'initials' : 'signature' }`,
    iAgreeToThe: `I agree to the`,
    eSignatureTerms: `eSignature Terms and Conditions`,
    adoptSign: (initials) => `Adopt & ${initials ? 'Initial' : 'Sign' }`,
    ok: `OK`,
    eSigningMustAgree: `Before eSigning you must agree to the eSignature Terms & Conditions`,
    eSignatureCheckbox: (orgName) => `
        By checking this box, you agree to be bound by the 
        <a href="/terms?org=${encodeURIComponent(orgName)}" target="_blank">eSignature Disclosure and Consent Statement</a>, 
        and hereby adopt the mark drawn, written or typed in the signature box as your signature as if you had affixed your ink signature to this document.
    `,
    enterFirstName: `Please enter your first name`,
    enterLastName: `Please enter your last name`,
    contactSearch: `Contact Search`,
    clear: `Clear`,
    typeToSearch: `Type to search`,
    searching: `Searching`,
    noContactsFound: `No Contacts Found`,
    searchContacts: `Search Contacts`,
    noEmailAddress: `No Email Address`,
    noEmailAddressDesc: `
        This Contact does not have an email address on file.
        You will not be able to send this form to them electronically until an email is added.
    `,
    chooseDate: `Click to choose a date`,
    chooseOption: `Choose an option`,
    filledWhenSigned: `This is filled automatically when the form is signed`,
    signaturePresent: `Signature is present`,
    signatureNotPresent: `Signature is not present`,
    initials: `Initials`,
    clickToInitial: `Click to initial`,
    clickToSign: `Click here to add signature`,
    requiredBeforeSigning: (num) => `${num} required fields must be filled in before signing.`,
    uploadFiles: (multiple) => `Upload ${multiple ? 'files' : 'a file'}`,
    orDragAndDrop: `or drag and drop`,
    removeFile: `Remove file`,
    uploadAnother: (multiple) => `${multiple ? 'Upload' : 'Choose' } another file`,
    maximumFileSizeAccepted: `Maximum file size accepted`,
    uploading: `Uploading`,
    dragDropOneFile: `Please only drag/drop one file`,
    unsupportedFileType: (fileName) => `The file "${fileName}" has an unsupported file type`,
    fileTooLarge: (fileName, maxFileSize) => `The file "${fileName}" is too large (maximum size is ${maxFileSize} MB)`,
    formLink: `Form link`,
    copy: `Copy`,
    copied: `Copied`,

    /**
     * dateformat localizations (undefined uses english default)
     */
    dayNames: undefined,
    monthNames: undefined,
    timeNames: undefined,

    /**
     * API Errors
     */
    // General errors
    'GEN-RNF': `Route or resource not found`,
    'GEN-SVE': `Server error`,
    'GEN-RTO': `Server connection failure (request timeout)`,
    'GEN-PDN': `Permission Denied`,
    'GEN-GAE': `Too many attempts`,
    'GEN-DNE': `Resource does not exist`,
    'GEN-IDS': `Invalid date selected`,
    'GEN-MRI': `Request is missing required information`,
    'GEN-PNF': `Partner not found`,
    'GEN-IRC': `Invalid region code`,
    
    // Filler errors
    'FILL-FAC': `This form has already been filled by another person and can no longer be saved`,
    'FILL-IAT': `Access to this form has been revoked by the sender and it can no longer be completed`,
    'FILL-IVF': `One or more field values are improperly formatted`,
    'FILL-MRI': `The request failed because some required information was missing`,
    'FILL-BAM': `This file type is not supported for attachments`,
    'FILL-ELF': `One or more fields have been edited which are locked and cannot be saved`,
    'FILL-RNC': `This form has been modified by the sender and can no longer be saved`,
    'FILL-PIN': `A PIN must be supplied to access this form`,
    'FILL-IPP': `Incorrect PIN`,
    'FILL-PAE': `Too many PIN attempts`,

    // Package errors
    'PKG-MRI': `The request failed because some required information was missing`,
    'PKG-PNE': `The requested form does not exist`,
    'PKG-UNP': `You no longer have access to this form`,
    'PKG-ISP': `The search request contains invalid parameters`,
    'PKG-ERR': `An internal error occurred while retrieving this form`,
    'PKG-PGF': `An internal error occurred while creating this PDF`,
    'PKG-PND': `Package is no longer a draft and cannot be deleted`,

    // Payment errors
    'PAY-NPP': `Payments have not been configured for this organization yet`,
    'PAY-PIC': `Payments have been incorrectly configured for this organization`,
    'PAY-PNE': `Payment no longer exists`,
    'PAY-PCE': `An error occurred while calculating the payment total. Please ensure all fields are filled in correctly and then try again.`,
};